import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const TomosSection = memo(function TomosSection() {
  const tomos = [{
    icon: '⚡',
    title: 'Tomo 1 — Fundamentos y Seguridad',
    subtitle: '¿Le tenés miedo a los cables? Esto se termina acá.',
    desc: 'Entendés cómo funciona la electricidad de tu casa y cómo trabajar sin poner en riesgo tu seguridad ni la de tu familia.',
    value: '$8.900'
  }, {
    icon: '🔧',
    title: 'Tomo 2 — Reparaciones del Hogar',
    subtitle: 'Lo que te cobran $15.000, lo resolvés en 15 minutos.',
    desc: 'Tomacorrientes, llaves de luz, empalmes e iluminación. Los arreglos más comunes de cualquier casa, paso a paso, sin llamar a nadie.',
    value: '$8.900'
  }, {
    icon: '🗂️',
    title: 'Tomo 3 — Tableros y Protecciones',
    subtitle: '¿Por qué salta el diferencial a las 11 de la noche?',
    desc: 'Aprendés a diagnosticar y resolver el problema vos mismo, sin esperar al técnico ni pagar una visita de emergencia.',
    value: '$8.900'
  }, {
    icon: '🏗️',
    title: 'Tomo 4 — Instalaciones',
    subtitle: '¿Estás refaccionando? No dejes que te cobren cualquier cosa.',
    desc: 'Entendés todo lo que se hace en una reforma eléctrica para que nadie te meta el dedo en la boca con un presupuesto inventado.',
    value: '$8.900'
  }, {
    icon: '📋',
    title: 'Tomo 5 — Nivel Avanzado',
    subtitle: 'Sabé cuándo te están mintiendo y cuándo no.',
    desc: 'Entendés las normas y verificaciones básicas para que el técnico no te pueda vender humo nunca más.',
    value: '$8.900'
  }, {
    icon: '🤖',
    title: 'Tomo 6 — Tu Casa del Futuro',
    subtitle: 'Pagá menos de luz y tené una casa más inteligente.',
    desc: 'Automatización simple y energía solar explicada sin tecnicismos. Para el que quiere modernizar su hogar y bajar la factura de una vez.',
    value: '$8.900'
  }];
  return <section className="py-16 bg-gray-50 text-gray-900 overflow-hidden border-t border-gray-200" data-id="element-181">
      <div className="max-w-5xl mx-auto px-4" data-id="element-182">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-183">
          <h2 className="text-[26px] md:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-184">
            Todo lo que contiene tu{' '}
            <span className="text-blue-600" data-id="element-185">
              Megapack Electricista en Casa:
            </span>
          </h2>
          <p className="text-gray-500 text-[13px] md:hidden" data-id="element-186">
            Deslizá para ver todos los tomos 👈
          </p>
        </div>
      </div>

      {/* Carrusel */}
      <div className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-6 px-[10vw] md:overflow-visible md:flex-wrap md:justify-center md:max-w-6xl md:mx-auto md:px-4 scrollbar-hide" data-id="element-187">
        {tomos.map((tomo, index) => <div key={index} className="snap-center flex-shrink-0 w-[80vw] md:w-[340px] bg-white rounded-2xl border border-gray-200 p-6 shadow-md hover:border-blue-300 transition-all duration-300 flex flex-col" data-id="element-188">
            {/* Header card */}
            <div className="mb-4" data-id="element-189">
              <div className="flex items-center gap-3 mb-2" data-id="element-190">
                <span className="text-3xl bg-gray-50 p-2 rounded-lg border border-gray-200" data-id="element-191">
                  {tomo.icon}
                </span>
                <h3 className="text-[17px] font-black text-gray-900 leading-tight" data-id="element-192">
                  {tomo.title}
                </h3>
              </div>
              <p className="text-blue-600 font-bold text-[13px] leading-snug mt-3" data-id="element-193">
                "{tomo.subtitle}"
              </p>
            </div>

            {/* Desc */}
            <p className="text-gray-600 text-[13px] leading-relaxed flex-1" data-id="element-194">
              {tomo.desc}
            </p>

            {/* Valor */}
            <div className="flex items-center justify-between border-t border-gray-200 pt-4 mt-4" data-id="element-195">
              <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-196">
                Valor Real
              </span>
              <span className="text-gray-400 font-bold line-through" data-id="element-197">
                {tomo.value}
              </span>
            </div>
          </div>)}
      </div>

      {/* Dots mobile */}
      <div className="flex justify-center gap-2 mt-4 md:hidden" data-id="element-198">
        {tomos.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-gray-300" data-id="element-199" />)}
      </div>

      {/* CTA */}
      <div className="max-w-5xl mx-auto px-4 mt-12" data-id="element-200">
        <CTAButton href="#compra" text="⚡ QUIERO RESOLVER MIS ARREGLOS SOLO" subtext="🔒 Compra protegida por MercadoPago — Garantía 30 días" data-id="element-201" />
      </div>
    </section>;
});